module.exports = __webpack_public_path__ + "assets/img/DigitalPictogram_INSTAGRAM.04f1d872.svg";